import React from 'react';
import { Switch } from 'antd';
import './style.scss';
import { noop } from 'lodash';

/**
 * FormSwitch component.
 *
 * @param {Object} props - Props for the FormSwitch component.
 * @param {Object} [props] - Additional props to be spread for the Switch component.
 * @returns {JSX.Element} The FormSwitch component.
 */
function FormSwitch({ ...props }) {
    return (
        <div className="form-switch">
            <label>
                <Switch size="small" {...props} />
            </label>
        </div>
    );
}

FormSwitch.defaultProps = {
    children: noop
}

export default FormSwitch;
